import React, { useState, useEffect, useRef } from 'react';
import FlyUpModal from '../FlyUpModal';
import { getFontStylesAsync } from '../../../../utils/StoreConfigManager';
import './ImageCarouselModal.css';
import { isMobileDevice } from 'web-store-modules/packages/obsess-device-detector';
import ModalOverlay from '../ModalOverlay';
import { StaticImage } from 'web-store-modules/packages/modal-media';
import { AppContext } from '../../../../AppContext';
import { CarouselArrowClicked, CarouselPopUpHotSpotClicked } from '../../../../utils/Analytics';
import { constructUrl } from '../../../../utils/UrlConstructor';

const isMobile = isMobileDevice();
const rightArrow = 'https://cdn.obsess-vr.com/vacheron/ARROW_Right.svg'
const leftArrow = 'https://cdn.obsess-vr.com/vacheron/ARROW_Legt.svg'
const closeIcon = 'https://cdn.obsess-vr.com/vacheron/vac_xicon_white.svg';

const extraTextHotspots = new Set(['60dce55ec584ff71d1029e2d', '60dce55ec584ff71d1029e2e']);

const dynamicTextHotspot = new Set(['60ec2d14fe1a005a6a499b73', '60ec26d4fe1a005a6a499b71', '60ec3201c584ff71d102c117']);

const ExtraTextContent = Object.freeze({
    '60dce55ec584ff71d1029e2e': {
        title: 'HERITAGE CLASSIC WITH A TWIST',
        description: 'Marking the 100th anniversary of the Historiques American 1921 watch, the "Classic with a twist" exhibition celebrates the creativity and boldness of Vacheron Constantin at the dawn of the 20th century. Through a selection of avant-garde historical pieces, from special-shaped ‘form’ watches to original displays, this exhibition mirrors an era marked by the carefree spirit of the Roaring Twenties and the aesthetic influence of the Art Deco movement. From the 1910s to the 1930s, from Geneva to the United States, it recounts the tastes of the time and the evolution in the art of wearing a watch. A pivotal period that Vacheron Constantin was able to accompany by developing an unexpected aesthetic vocabulary in which technique and style converse in subtle harmony between the conventional and the atypical.'
    },
    '60dce55ec584ff71d1029e2d': {
        title: 'AMERICAN 1921, A BRIDGE BETWEEN THE PAST AND FUTURE OF THE MAISON',
        description: 'To mark the 100th anniversary of the American 1921 watch, Vacheron Constantin has delved into its archives and its horological expertise to offer a faithful reproduction of the timepiece emblematic of an era. This exceptional one-of-a-kind creation mobilised the remarkable expertise of the Maison’s Restoration workshop and the Heritage department for an entire year. This approach might be a first in the watch industry, reflecting Vacheron Constantin’s commitment to the conservation, transmission and continuous enrichment of its heritage and of traditional skills.'
    }
})

const swipeThreshold = 100;

const ImageCarouselModal = ({ modalContent, onModalHidden, currentSceneName, hotspotId }) => {
    const { pages } = modalContent;
    const [fontStyles, setFontStyles] = useState();
    const modalRef = useRef();
    const [carouselWidth, setCarouselWidth] = useState();
    const [distOffset, setDistOffset] = useState(0);
    const [currentIndex, setCurrentIndex] = useState(0);
    const [xTranslation, setXTranslation] = useState(0);
    const carouselContainer = useRef();
    const totalItems = pages.length;
    const [allItems, setallItems] = useState(totalItems);
    const [showExtraText, setshowExtraText] = useState(false);
    const [startPos, setStartPos] = useState(0);
    const [isUserMoving, setIsUserMoving] = useState(false);
    const [isUserInteracting, setIsUserInteracting] = useState(false);
    const [startTime, setStartTime] = useState(0);
    const [endPos, setEndPos] = useState(0);
    const [endTime, setEndTime] = useState(0);

    useEffect(() => {
        if (ExtraTextContent[hotspotId]) {
            CarouselPopUpHotSpotClicked(ExtraTextContent[hotspotId]['title'])
        }
        else if (dynamicTextHotspot.has(hotspotId) && pages.length > 0) {
            CarouselPopUpHotSpotClicked(pages[0].title)
        } else if (hotspotId === '60e88fb937950a94f897e0a2') {
            CarouselPopUpHotSpotClicked('watchmaker')
        }
    }, []);

    useEffect(() => {


        fetchFontStyles();
        addListeners();
        checkSceneForTextContent();
        return (() => {
            removeListeners();
        });
    }, []);

    useEffect(() => {
        if (carouselContainer.current && carouselContainer.current.clientWidth)
            setCarouselWidth(carouselContainer.current.clientWidth);
    }, [carouselContainer.current]);

    useEffect(() => {
        setDistOffset(carouselWidth * currentIndex);
    }, [currentIndex, carouselWidth])

    useEffect(() => {
        setXTranslation(distOffset ? -distOffset : 0);
    }, [distOffset])

    const addListeners = () => {
        if (isMobile) {
            window.addEventListener('touchend', handleModalClose);
        } else {
            window.addEventListener('click', handleModalClose);
        }
    }

    const removeListeners = () => {
        if (isMobile) {
            window.removeEventListener('touchend', handleModalClose);
        } else {
            window.removeEventListener('click', handleModalClose);
        }
    }

    const fetchFontStyles = () => {
        getFontStylesAsync()
            .then((fontStyles) => setFontStyles(fontStyles))
            .catch((err) => console.error(err));

    }

    const checkSceneForTextContent = () => {
        if (extraTextHotspots.has(hotspotId)) {
            setallItems(allItems + 1);
            setshowExtraText(true)
        }
    }

    const handleModalClose = (e) => {
        if (modalRef && modalRef.current.contains(e.target)) {
            return;
        }
    }
    const textItem = () => {
        const productImageStyle = { display: 'inline', minWidth: '100%', minHeight: '100%', objectFit: 'contain', transition: 'all 500ms', padding: '0', transform: `translate(${xTranslation}px, 0px)` };

        return pages.map((x, i) => {
            return (
                <div className='text-modal-html-container' key={i} style={productImageStyle}>
                    <span style={{ fontSize: '24px', fontFamily: 'PreloCondensed Light', marginBottom: '5px', color: '#000000' }}> {x.title} </span>
                    <div className="modal-description">
                        {(dynamicTextHotspot.has(hotspotId) && x.description && x.description != '') ?
                            <p className="description">{x.description}</p>
                            : <img src={constructUrl(x.image)} className="image-carousel-container" style={{ maxHeight: '100%', maxWidth: '100%', paddingTop: '10px', objectFit: 'contain' }} />}
                    </div>
                    <p className="subtitle">{x.subtitle}</p>
                </div>
            )
        })
    }

    const staticTextContent = () => {
        const productImageStyle = { display: 'inline', minWidth: '100%', minHeight: '100%', objectFit: 'contain', transition: 'all 500ms', padding: '0', transform: `translate(${xTranslation}px, 0px)` };
        return (
            <div className='text-modal-html-container extra-text-content' style={productImageStyle}>
                <span className="modal-title-container" style={{ fontSize: '24px', fontFamily: 'PreloCondensed Light', marginBottom: '5px', color: '#000000' }}> {ExtraTextContent[hotspotId]['title']} </span>
                <div className="modal-description extra-text-content">
                    {/* <img src={constructUrl(x.image)} style={{ height: '300px', width: '250px', paddingTop: '10px' }} /> */}
                    <p className="description">{ExtraTextContent[hotspotId]['description']}</p>
                </div>
                <p className="subtitle">{ }</p>
            </div>
        )
    }

    const onclickHandler = (arrowType) => {
        if (arrowType == 'left-arrow') {
            setCurrentIndex(currentIndex - 1);
        } else {
            setCurrentIndex(currentIndex + 1);
        }
        //CarouselArrowClicked(currentSceneName);
    }

    const getSign = (num) => Math.sign(num);

    const withinBounds = (index, min, max) => (index < min || index + 1 > max) ? false : true;

    const onMouseDown = (e) => {
        e.preventDefault();
        setStartPos(e.clientX);
        setStartTime(Date.now())
        setIsUserMoving(true);
    }

    const onMouseMove = (e) => {
        e.preventDefault();
        if (isUserMoving && !isUserInteracting) {
            setEndPos(e.clientX);
            setEndTime(Date.now());
        }
    }

    const onMouseUp = (e) => {
        e.preventDefault();
        const dist = startPos - endPos;
        const isUserSwiping = Math.abs(startTime - endTime) < swipeThreshold ? true : false;
        if ((Math.abs(dist) > (carouselWidth * 0.4) || isUserSwiping) && endPos) {
            if (withinBounds(currentIndex + (getSign(dist) * 1), 0, allItems)) {
                setCurrentIndex(currentIndex + (getSign(dist) * 1));
            }
        }

        setStartPos(0);
        setEndPos(0);
        setIsUserMoving(false);
    }

    const onTouchStart = (e) => {
        setStartPos(e.touches[0].pageX);
        setStartTime(Date.now())
        if (!carouselWidth) {
            setCarouselWidth((carouselContainer.current.clientWidth));
        }
    }

    const onTouchMove = (e) => {
        if (!isUserInteracting) {
            setEndPos(e.touches[0].pageX);
            setEndTime(Date.now());

            setIsUserMoving(true);
        }
    }

    const onTouchEnd = () => {
        const dist = startPos - endPos;
        const isUserSwiping = Math.abs(startTime - endTime) < swipeThreshold ? true : false;

        if ((Math.abs(dist) > (carouselWidth * 0.4) || isUserSwiping) && endPos) {
            if (withinBounds(currentIndex + (getSign(dist) * 1), 0, allItems)) {
                setCurrentIndex(currentIndex + (getSign(dist) * 1));
            }
        }

        setStartPos(0);
        setEndPos(0);
        setIsUserMoving(false);
    }

    const textContainer = () => {
        return (
            <div className='text-modal-carousel'
                onMouseDown={onMouseDown}
                onMouseMove={onMouseMove}
                onMouseUp={onMouseUp}
                onTouchStart={onTouchStart}
                onTouchMove={onTouchMove}
                onTouchEnd={onTouchEnd}
                ref={carouselContainer} style={{ overflowY: currentIndex == 0 ? 'hidden' : 'auto' }}>
                {showExtraText && staticTextContent()}
                {textItem()}
            </div>
        )
    }

    const arrowIndicatore = () => {
        return (
            <div className='text-modal-arrow'>
                {currentIndex > 0 && <div className="left-arrow" onClick={() => onclickHandler('left-arrow')}><img src={leftArrow} alt='left-arrow' /></div>}
                {allItems > 1 && (currentIndex + 1) < allItems && <div className="right-arrow image-carousel" onClick={() => onclickHandler('right-arrow')}><img src={rightArrow} alt='right-arrow' /></div>}
            </div>
        )
    }

    const renderModalContent = () => {
        return (
            <div className='text-modal-content' style={{ textAlign: 'center' }} ref={modalRef}>
                {arrowIndicatore()}
                {textContainer()}
            </div>
        )
    }

    return (
        //Added the isImage Loaded bool here to display the close button on the Modal due to a condition in Modal.jsx
        <FlyUpModal extraClassName={(showExtraText || dynamicTextHotspot.has(hotspotId)) ? "text-image-modal-container extra-text-main-container" : "text-image-modal-container"} onModalHidden={onModalHidden} isOpaque
            textPopup hideCloseIcon isImageLoaded closeIconImage={closeIcon}>
            <ModalOverlay />
            {!!fontStyles && renderModalContent()}
        </FlyUpModal>
    );
}

export default props => (
    <AppContext.Consumer>
        {appContextValue => (
            <ImageCarouselModal {...props} currentSceneName={appContextValue.currentSceneName} />
        )}
    </AppContext.Consumer>
);